import { first, switchMap } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ActivatedRouteSnapshot } from '@angular/router';

import { CheckoutState, checkoutQuery, fromCheckoutActions } from '../+state';

@Injectable()
export class CreditBundleResolver {
  constructor(private _store: Store<CheckoutState>) {}

  /*
   * Resolve CreditBundle
   * 1. Selects CreditBundle from the store
   * 2. Checks CreditBundle.id is present
   *    -If it doesn't exist:
   *    1. GetCreditBundle with :id
   * 3. Checks paramQuoteUuid from url with present id
   *    - If it doesn't match:
   *    1. GetCreditBundle with :id
   *    - If it does match:
   *    1. Return getCreditBundle from Store
   */
  public resolve(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this._store.pipe(select(checkoutQuery.getSelectedCreditBundle), first()).pipe(
      switchMap(() => {
        // TODO
        // for now we cannot use cached data
        // there is no delta sync/realtime infrastructure
        const paramCreditBundleUuid = route.params.creditBundleUuid;
        this.getCreditBundle(paramCreditBundleUuid);
        return of(true);

        // if (!creditBundle) {
        //   return this.getCreditBundle(paramCreditBundleUuid);
        // }

        // if (paramCreditBundleUuid !== creditBundle.uuid) {
        //   return this.getCreditBundle(paramCreditBundleUuid);
        // }

        // return of(creditBundle);
      })
    );
  }

  /*
   * trigger fetching quote to send
   * 1. Dispatch getCreditBundle action
   * 2. Listening to setCreditBundle
   * 3. Return payload of setCreditBundle
   */
  private getCreditBundle(id: string) {
    this._store.dispatch(fromCheckoutActions.getSelectedCreditBundle({ payload: { id } }));
  }
}
